module.exports = __webpack_public_path__ + "static/media/img4.dd9d5b25.jpg";